<script setup>

import {useStore} from "vuex";
import {computed, onMounted, ref, watch} from "vue";
import {CameraController, SpeckleLoader, UrlHelper, Viewer} from "@speckle/viewer";
import {TOKEN} from "@/speckleUtils";

// Vuex
const store   = useStore();
// Variables
const viewer  = ref(null);
const loading = ref(false);
const wall = ref(null);
// Computed
const items   = computed(() => {
  return Object.keys(store.state.scheduleTable.walls);
});
// Watchers
watch(
    () => store.state.scheduleTable.selectedWallType,
    (newValue) => {
      if (newValue) {
        store.commit("setActiveWallType", {
          wallType: newValue.toLowerCase().replaceAll(" ", "")
        });
      } else {
        store.commit("setActiveWallType", {
          wallType: null
        });
      }
    }
);
watch(
    () => store.state.modelViewer.prefabWalls.activeWallType,
    async (newValue) => {
      if (newValue) {
        loading.value  = true;
        const wallType = store.state.modelViewer.prefabWalls.wallTypes.find((wallType) => wallType.name === newValue);
        if (wallType) {
          const token     = localStorage.getItem(TOKEN);
          const urls      = await UrlHelper.getResourceUrls(
              `https://app.speckle.systems/projects/144ada10be/models/${wallType.id}`,
              token
          );
          const container = document.querySelector("#prefab-wall-viewer");
          const canvas    = container.getElementsByTagName('canvas');
          if (canvas.length > 0) {
            container.removeChild(canvas[0]);
          }
          const v = new Viewer(container);
          v.createExtension(CameraController);
          const viewerCameraController              = v.getExtension(CameraController);
          viewerCameraController.options.enablePan  = false;
          viewerCameraController.options.enableZoom = false;
          for (const url of urls) {
            const loader = new SpeckleLoader(v.getWorldTree(), url, token);
            await v.loadObject(loader, true);
          }
          viewer.value = v;
          await viewer.value.init();
        }
        loading.value = false
      }
    }
);
watch(wall, (newWall) => {
  store.commit("setScheduleSelectedWallType", newWall);
});
// Lifecycle hooks
onMounted(async () => {
  await store.dispatch("fetchScheduleTableData");
  const prefabricatedWallType = store.state.projectData?.panelCountEstimator?.prefabricatedWallType;
  wall.value = items.value.find(
      (item) => item === prefabricatedWallType
    ) ?? null
});
</script>

<template>
  <v-select v-model="wall"
            :items="items"
            :label="$t('placeholders.prefabWallType')"></v-select>
  <v-sheet id="prefab-wall-viewer">
    <v-skeleton-loader v-if="loading"
                       class="prefab-wall-skeleton"
    ></v-skeleton-loader>
  </v-sheet>
</template>

<style scoped>
@import '@/assets/styles/components/viewer/PrefabWallViewer.css';
</style>